import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchValidationRules,
  getValidationRulesByID,
  updateValidationRules
} from "../../../api/endpoint";

function* getValidationRulesSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(fetchValidationRules, action.payload);
    yield put(actions.setValidationRules(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getValidationRuleByIDSaga(action) {
  try {
    console.log("****** getValidationRuleByIDSaga", action);
    const _api = yield call(getValidationRulesByID, action.payload);
    console.log("****** ", _api);
    yield put(actions.setValidationRulesById(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* updateValidationRuleSaga(action) {
  try {
    const _api = yield call(updateValidationRules, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "Validation Rule Successfully Updated",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setError(true));
    yield put(commonActions.setRedirect(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message,
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
  }
}

export function* watchValidationRulesSaga() {
  yield all([
    takeEvery(actionTypes.GET_VALIDATION_RULES, getValidationRulesSaga),
    takeEvery(actionTypes.GET_VALIDATION_RULE_BY_ID, getValidationRuleByIDSaga),
    takeEvery(actionTypes.UPDATE_VALIDATION_RULE, updateValidationRuleSaga),
  ]);
}
